import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { InspectionHttpRestoreRequestModel } from '../httpQueue/inspection/types';

export interface RestoreInspectionParams {
  inspectionId: string;
  projectId: string;
  uniqueId: string;
}

export class InspectionRestorer {
  constructor(
    private addRequest: (
      request: InspectionHttpRestoreRequestModel
    ) => Promise<unknown>
  ) {}

  async execute({
    inspectionId,
    projectId,
    uniqueId,
  }: RestoreInspectionParams): Promise<void> {
    debugLog('RestoreInspectionUseCase', inspectionId);
    await this.addRequest({
      createdAt: Date.now(),
      method: 'GET',
      data: {
        inspectionId,
        projectId,
        uniqueId,
      },
      url: `/project/${projectId}/inspection/${inspectionId}/restore`,
      entityType: HttpRequestModelType.inspection,
      status: HttpRequestStatus.NEW,
    });
  }
}

export const inspectionRestorer = new InspectionRestorer(addRequest);
